import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
export function TestimonialsTop() {
  const testimonials = [{
    quote: 'No creía que la comida pudiera afectar tanto mi sueño. Bajé 4 kilos en el primer mes sin hacer dieta. Solo cambié mis cenas.',
    name: 'Ricardo M.',
    meta: '47 años · Guadalajara',
    avatar: 'https://i.pravatar.cc/150?u=ricardo'
  }, {
    quote: 'Las recetas son deliciosas y rapidísimas. Mi esposo y yo las hacemos juntos. Dormimos mejor y tenemos más energía para todo.',
    name: 'Patricia L.',
    meta: '49 años · Monterrey',
    avatar: 'https://i.pravatar.cc/150?u=patricia'
  }];
  return <section className="w-full bg-ivory py-20 px-6" data-id="element-175">
      <div className="max-w-[1200px] mx-auto" data-id="element-176">
        <h2 className="font-serif text-3xl md:text-4xl text-botanic text-center mb-16" data-id="element-177">
          Lo que dicen quienes ya lo probaron
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-178">
          {testimonials.map((t, i) => <motion.div key={i} whileHover={{
          y: -5
        }} className="bg-white p-8 rounded-xl shadow-sm border border-gold/30 relative" data-id="element-179">
              <div className="flex gap-1 mb-4" data-id="element-180">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-gold text-gold" data-id="element-181" />)}
              </div>
              <p className="text-ink-soft italic mb-8 min-h-[100px]" data-id="element-182">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-4" data-id="element-183">
                <div data-id="element-184">
                  <p className="font-bold text-botanic" data-id="element-185">{t.name}</p>
                  <p className="text-sm text-ink-soft" data-id="element-186">{t.meta}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}